var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4057 15.999L0.951172 19.499V0.999023C0.951172 0.733807 1.05652 0.479453 1.24403 0.291917C1.43155 0.10438 1.68588 -0.000976562 1.95107 -0.000976562H19.9491C20.2143 -0.000976562 20.4687 0.10438 20.6562 0.291917C20.8437 0.479453 20.949 0.733807 20.949 0.999023V14.999C20.949 15.2642 20.8437 15.5186 20.6562 15.7061C20.4687 15.8937 20.2143 15.999 19.9491 15.999H5.4057ZM4.71377 13.999H18.9493V1.99902H2.95096V15.384L4.71377 13.999ZM9.95021 6.99902H11.95V8.99902H9.95021V6.99902ZM5.95064 6.99902H7.95043V8.99902H5.95064V6.99902ZM13.9498 6.99902H15.9496V8.99902H13.9498V6.99902Z",
    fill: "#121212"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.75d1cb9b1f574238a78ae81007c2d56e.svg";
export { ForwardRef as ReactComponent };